import * as React from "react";
import { FaCircle } from "react-icons/fa";
import { FaRegCircle } from "react-icons/fa";
import { WcColourRatingObject } from "../WcSmiley/WcSmiley";
import { Radio, RadioGroup, RadioGroupProps, RadioProps } from "@mui/material";
import { forEach } from "lodash";

export type WcTrafficLightProps = RadioGroupProps &
  RadioProps & {
    colors?: any;
    numberOfCircles?: NumberOfCircles;
    // handleChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  };

export type NumberOfCircles = 3 | 5;

// -------------------------------FULL TRAFFIC LIGHT RADIO GROUP--------------------------------------

export const WcTrafficLight = ({ value, colors, numberOfCircles = 5, ...others }: WcTrafficLightProps) => {
  const controlProps = (item: number) => ({
    //checked: item === value,
    //onChange: onChange,
    // value: item,
    // name: "size-radio-button-demo",
    inputProps: { "aria-label": item.toString() },
  });

  const radioButtons = () => {
    const radioButtonsArray = [];
    for (let i = 1; i <= 5; i++) {
      radioButtonsArray.push(
        <Radio
          key={i}
          value={i}
          checked={i === parseInt(value, 10)}
          checkedIcon={<FaCircle fontSize="inherit" />}
          icon={<FaRegCircle fontSize="inherit" />}
          {...controlProps(i)}
          sx={{
            color: colors[i],
            "&.Mui-checked": {
              color: colors[i] || "",
            },
          }}
        />
      );
      if (numberOfCircles === 3) {
        i++;
      }
    }

    return radioButtonsArray;
  };

  return (
    <RadioGroup value={parseInt(value, 10)} row {...others}>
      {radioButtons()}
    </RadioGroup>
  );
};

export default WcTrafficLight;
// ------------------------------------------------------------------------------------------------------------

// ------------------------------------SINGLE SELECTED TRAFFIC LIGHT ICON-------------------------------------

export interface WcTrafficLightSingleIconProps {
  value: number;
  colors: WcColourRatingObject;
  fontSize?: string;
}

export const WcTrafficLightSingleIcon = ({ value, colors, fontSize = "inherit" }: WcTrafficLightSingleIconProps) => (
  //@ts-ignore
  (<FaCircle fontSize={fontSize} color={colors[value]} />)
);
// --------------------------------------------------------------------------------------------------------------
